export default __webpack_public_path__ + "geomanist-ultra-webfont.7e0ee86cb44b1ce197873efb7ac13ed9.woff";